<template>
  <div class="goods-code">
    <div class="search-container">
      <el-form :inline="true" class="search-form">
        <el-form-item label="商品编码">
          <el-input placeholder="请输入商品编码"></el-input>
        </el-form-item>
        <el-form-item label="基础品名">
          <el-input placeholder="请输入基础品名"></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select v-model="searchForm.enabled" placeholder="全部">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否过期">
          <el-select v-model="searchForm.expired" placeholder="全部">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否0退税">
          <el-select v-model="searchForm.zeroTax" placeholder="全部">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜索</el-button>
          <el-button>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="操作" width="240" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showChangeRecord(scope.row.code)">变更记录</el-button>
          <el-button v-if="scope.row.enabled" type="text" size="small" @click="toggleEnabled(scope.row, false)" style="color: red;">禁用</el-button>
          <el-button v-else type="text" size="small" @click="toggleEnabled(scope.row, true)">启用</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="商品编码"></el-table-column>
      <el-table-column prop="name" label="基础品名"></el-table-column>
      <el-table-column prop="enabled" label="是否启用" width="80">
        <template slot-scope="scope">
          <span :class="scope.row.enabled ? 'status-enabled' : 'status-disabled'">
            {{ scope.row.enabled ? '是' : '否' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="expired" label="是否过期" width="80">
        <template slot-scope="scope">
          <span :class="scope.row.expired ? 'status-expired' : 'status-not-expired'">
            {{ scope.row.expired ? '是' : '否' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="version" label="当前版本号"></el-table-column>
      <el-table-column prop="taxRate" label="退税率"></el-table-column>
      <el-table-column prop="remark" label="商品备注"></el-table-column>
      <el-table-column prop="spec" label="要素申报规范" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="unit1" label="法一单位"></el-table-column>
      <el-table-column prop="unit2" label="法二单位"></el-table-column>
      <el-table-column prop="dangerous" label="是否危险品">
        <template slot-scope="scope">
          <span>{{ scope.row.dangerous ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="regulatoryCode" label="监管条件代码"></el-table-column>
      <el-table-column prop="检疫Class" label="检验检疫类别"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="180"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    
    <!-- 变更记录弹框 -->
    <el-dialog
      :title="`海关基础数据变更记录(${selectedCode})`"
      :visible.sync="dialogVisible"
      width="70%"
      :close-on-click-modal="true">
      <el-table :data="changeRecords" style="width: 100%">
        <el-table-column prop="time" label="变更时间"></el-table-column>
        <el-table-column prop="field" label="字段"></el-table-column>
        <el-table-column prop="oldValue" label="原值"></el-table-column>
        <el-table-column prop="newValue" label="新值"></el-table-column>
        <el-table-column prop="version" label="版本号"></el-table-column>
        <el-table-column prop="user" label="变更用户"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'GoodsCode',
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 200,
      dialogVisible: false,
      selectedCode: '',
      changeRecords: [],
      searchForm: {
        enabled: '',
        expired: '',
        zeroTax: ''
      }
    }
  },
  mounted() {
    this.generateTableData()
  },
  methods: {
    generateTableData() {
      this.tableData = [
        {
          code: '8517121000',
          name: '手机',
          version: '20260401',
          enabled: true,
          expired: false,
          taxRate: '13%',
          remark: '智能移动电话',
          spec: '品牌类型*|出口享惠情况*|材质(竹制)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '012 - 台',
          unit2: '020 - 个',
          dangerous: false,
          regulatoryCode: 'A',
          检疫Class: 'M',
          createTime: '2026-04-01 10:00:00',
          updateTime: '2026-04-15 14:30:00'
        },
        {
          code: '8471300000',
          name: '笔记本电脑',
          version: '20260402',
          enabled: true,
          expired: false,
          taxRate: '13%',
          remark: '便携式计算机',
          spec: '品牌类型*|出口享惠情况*|材质(竹制)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '012 - 台',
          unit2: '020 - 个',
          dangerous: false,
          regulatoryCode: 'B',
          检疫Class: 'N',
          createTime: '2026-04-02 09:00:00',
          updateTime: '2026-04-16 11:00:00'
        },
        {
          code: '8703231400',
          name: '轿车',
          version: '20260403',
          enabled: true,
          expired: false,
          taxRate: '10%',
          remark: '排气量1.6升以下',
          spec: '品牌类型*|出口享惠情况*|材质(竹制)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '044 - 辆',
          unit2: '012 - 台',
          dangerous: false,
          regulatoryCode: 'C',
          检疫Class: 'P',
          createTime: '2026-04-03 15:00:00',
          updateTime: '2026-04-17 10:00:00'
        },
        {
          code: '9013803000',
          name: '相机',
          version: '20260404',
          enabled: false,
          expired: true,
          taxRate: '13%',
          remark: '数码相机',
          spec: '品牌类型*|出口享惠情况*|材质(竹制)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '012 - 台',
          unit2: '020 - 个',
          dangerous: false,
          regulatoryCode: 'D',
          检疫Class: 'Q',
          createTime: '2026-04-04 08:00:00',
          updateTime: '2026-04-18 16:00:00'
        },
        {
          code: '7118100000',
          name: '珠宝',
          version: '20260405',
          enabled: true,
          expired: false,
          taxRate: '13%',
          remark: '黄金首饰',
          spec: '品牌类型*|出口享惠情况*|材质(黄金)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '036 - 克',
          unit2: '021 - 件',
          dangerous: false,
          regulatoryCode: 'E',
          检疫Class: 'R',
          createTime: '2026-04-05 13:00:00',
          updateTime: '2026-04-19 09:30:00'
        },
        {
          code: '6205200000',
          name: '服装',
          version: '20260406',
          enabled: true,
          expired: false,
          taxRate: '13%',
          remark: '棉制上衣',
          spec: '品牌类型*|出口享惠情况*|材质(棉)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '021 - 件',
          unit2: '050 - 套',
          dangerous: false,
          regulatoryCode: 'F',
          检疫Class: 'S',
          createTime: '2026-04-06 14:00:00',
          updateTime: '2026-04-20 15:00:00'
        },
        {
          code: '6403990000',
          name: '鞋子',
          version: '20260407',
          enabled: true,
          expired: false,
          taxRate: '13%',
          remark: '运动鞋',
          spec: '品牌类型*|出口享惠情况*|材质(鞋)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '051 - 双',
          unit2: '020 - 个',
          dangerous: false,
          regulatoryCode: 'G',
          检疫Class: 'T',
          createTime: '2026-04-07 10:30:00',
          updateTime: '2026-04-21 11:30:00'
        },
        {
          code: '9102110000',
          name: '手表',
          version: '20260408',
          enabled: true,
          expired: false,
          taxRate: '13%',
          remark: '机械手表',
          spec: '品牌类型*|出口享惠情况*|材质(手表)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '021 - 件',
          unit2: '020 - 个',
          dangerous: false,
          regulatoryCode: 'H',
          检疫Class: 'U',
          createTime: '2026-04-08 09:30:00',
          updateTime: '2026-04-22 10:30:00'
        },
        {
          code: '9004100000',
          name: '眼镜',
          version: '20260409',
          enabled: true,
          expired: false,
          taxRate: '13%',
          remark: '光学眼镜',
          spec: '品牌类型*|出口享惠情况*|材质(眼镜)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '021 - 件',
          unit2: '020 - 个',
          dangerous: false,
          regulatoryCode: 'I',
          检疫Class: 'V',
          createTime: '2026-04-09 11:00:00',
          updateTime: '2026-04-23 14:00:00'
        },
        {
          code: '9403300000',
          name: '家具',
          version: '20260410',
          enabled: true,
          expired: false,
          taxRate: '13%',
          remark: '木质沙发',
          spec: '品牌类型*|出口享惠情况*|材质(沙发)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '021 - 件',
          unit2: '050 - 套',
          dangerous: false,
          regulatoryCode: 'J',
          检疫Class: 'W',
          createTime: '2026-04-10 16:00:00',
          updateTime: '2026-04-24 16:30:00'
        }
      ]
    },
    formatDateTime(date) {
      return date.getFullYear() + '-' + 
             String(date.getMonth() + 1).padStart(2, '0') + '-' + 
             String(date.getDate()).padStart(2, '0') + ' ' +  
             String(date.getHours()).padStart(2, '0') + ':' + 
             String(date.getMinutes()).padStart(2, '0') + ':' + 
             String(date.getSeconds()).padStart(2, '0')
    },
    showChangeRecord(code) {
      this.selectedCode = code
      this.changeRecords = []
      for (let i = 0; i < 8; i++) {
        const date = new Date()
        date.setDate(date.getDate() - i)
        date.setHours(10 + i, 30 + i * 5)
        
        this.changeRecords.push({
          index: i + 1,
          time: this.formatDateTime(date),
          field: ['是否零退税', '出口退税率', '是否已过期', '商品描述', '出口基准单价', '申报要素规范', '是否为危险品', '检验检疫类别'][i % 10],
          oldValue: i % 2 === 0 ? '否' : '-',
          newValue: ['是', '0退税', '是', '包括初榨红花油的分离品', '0.0', '品牌类型*|出口享惠情况*|材质(竹制)*|种类*|是否为一次性制品*|GTIN|CAS|其他', '是', 'RS'][i % 10],
          version: '20260401 -> 20260427',
          user: ['张明', '刘伟', '陈静', '赵强', '孙丽'][i % 5]
        })
      }
      this.dialogVisible = true
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.generateTableData()
    },
    handleCurrentChange(current) {
      this.currentPage = current
      this.generateTableData()
    },
    toggleEnabled(row, enabled) {
      row.enabled = enabled
      this.$message({
        type: 'success',
        message: `商品编码 ${row.code} 已${enabled ? '启用' : '禁用'}`
      })
    }
  }
}
</script>

<style scoped>
.goods-code {
  padding: 0;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: var(--text-primary);
  display: inline-block;
  padding-bottom: 8px;
  border-bottom: 3px solid var(--primary-color);
}

.search-container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid var(--border-color);
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
}

.search-form >>> .el-form-item {
  margin-bottom: 0;
}

.search-form >>> .el-form-item__label {
  font-weight: 500;
  color: var(--text-secondary);
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
}

.status-enabled {
  color: var(--success-color);
  font-weight: 500;
}

.status-disabled {
  color: var(--danger-color);
  font-weight: 500;
}

.status-expired {
  color: var(--warning-color);
  font-weight: 500;
}

.status-not-expired {
  color: var(--success-color);
  font-weight: 500;
}

.table-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.table-actions .el-button {
  padding: 4px 8px;
  font-size: 13px;
}

.table-actions .el-button--text {
  padding: 4px 6px;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}

.goods-code >>> .el-table {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border-color);
}

.goods-code >>> .el-table th {
  background-color: #fafafa !important;
  font-weight: 600;
  color: var(--text-primary);
  font-size: 13px;
}

.goods-code >>> .el-table td {
  padding: 12px 0;
  font-size: 13px;
}

.goods-code >>> .el-table__row:hover > td {
  background-color: var(--primary-bg) !important;
}

.goods-code >>> .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.goods-code >>> .el-dialog__header {
  background-color: #fff;
  border-bottom: 1px solid var(--border-color);
  padding: 18px 24px;
}

.goods-code >>> .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.goods-code >>> .el-dialog__body {
  padding: 20px 24px;
}

.goods-code >>> .el-dialog__footer {
  border-top: 1px solid var(--border-color);
  padding: 14px 24px;
}

.goods-code >>> .el-table--border {
  border: 1px solid var(--border-color);
}

.goods-code >>> .el-table--border th,
.goods-code >>> .el-table--border td {
  border-right: 1px solid var(--border-color);
}
</style>